module.exports = __webpack_public_path__ + "static/img/s4.b7dc765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s4.jpg
// module id = 6qto
// module chunks = 0